const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

const applyReducedMotion = () => {
  document.documentElement.dataset.reducedMotion = mediaQuery.matches ? 'true' : 'false';
};

applyReducedMotion();
mediaQuery.addEventListener?.('change', applyReducedMotion);
